/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import moment from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import { MENU_WIDTH } from '../constants';
import { getHistory } from '../store/actions/history';
import { getPatient } from '../store/actions/patients';
import FilterPanel from '../components/FilterPanel';

const columns = [
  {
    id: 'startTime',
    label: 'Pause Start Time',
    minWidth: 170,
    align: 'center',
    format: (value) => moment(value).format('MMM D, h:mm A'),
  },
  {
    id: 'endTime',
    label: 'Pause End Time',
    minWidth: 170,
    format: (value) => (value === null ? 'N/A' : moment(value).format('MMM D, h:mm A')),
    align: 'center',
  }
];

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
    height: '100%',
  },
  paper: {
    margin: '2em',
  },
  content: {
    flexGrow: 1,
    borderRadius: 4,
  },
  table: {
    width: '100%',
  },
  headerCell: {
    backgroundColor: '#526488',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'white',
  },
  top: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '2rem 2rem 0 2rem',
  },
}));

const PauseDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const historyList = useSelector((state) => state.history.historyList);
  const historyCount = useSelector((state) => state.history.historyCount);
  const currentPatient = useSelector((state) => state.patients.currentPatient);
  const [displayList, setDisplayList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const classes = useStyles();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [deviceValue, setDeviceValue] = useState(sessionStorage.getItem('device'));
  const [idsValue, setIdsValue] = useState(sessionStorage.getItem('ids'));
  const requestScreen = 'pauses';

  useEffect(() => {
    dispatch(getHistory(page + 1, rowsPerPage, startDate, endDate, id, deviceValue ,idsValue, requestScreen));
    if (!currentPatient || currentPatient.id.toString() !== id) {
      dispatch(getPatient(id));
    }
  }, [id]);

  useEffect(() => {
    setDisplayList(
      historyList.map((row) => {
        return {
          startTime: row.start_date,
          endTime: row.end_date
        };
      }),
    );
  }, [historyList]);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    dispatch(getHistory(newPage + 1, rowsPerPage, startDate, endDate, id, deviceValue, idsValue, requestScreen));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    dispatch(getHistory(1, +event.target.value, startDate, endDate, id, deviceValue, idsValue, requestScreen));
  };

  const onFiltersChanged = (filters) => {
    setStartDate(filters.start);
    setEndDate(filters.end);
    dispatch(getHistory(page + 1, rowsPerPage, filters.start, filters.end, filters.patient, deviceValue, idsValue, requestScreen));
  };
  
  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <h2 className={classes.patient}>
          {currentPatient && currentPatient.id.toString() === id
            ? `Patient: ${currentPatient.first_name} ${currentPatient.last_name}`
            : ''}
        </h2>
        <h2 className={classes.patient}>
          {deviceValue
            ? `Monitor: ${deviceValue}`
            : ''}
        </h2>
        <FilterPanel onChange={onFiltersChanged} id={parseInt(id, 10)} device={deviceValue} button={false} />
      </div>
      <Paper className={classes.paper}>
        <TableContainer className={classes.content}>
          <Table stickyHeader aria-label="sticky table" className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell
                    className={classes.headerCell}
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {displayList.map((row, index) => {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <TableRow className={classes.row} hover key={index}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align} className={classes.cell}>
                          {column.format ? column.format(value, row) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={historyCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
};

export default PauseDetails;
